module.exports = __webpack_public_path__ + "img/circle_help_dark_grey.4777005a.png";